import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import { ExchangeRates, LoadingStatus } from '@qvs/core';
import * as fromActions from './exchangeRates.actions';

export interface ExchangeRatesState {
  exchangeRates: ExchangeRates;
  loadingStatus: LoadingStatus;
}

export const initialState: ExchangeRatesState = {
  exchangeRates: {},
  loadingStatus: LoadingStatus.IDLE
};

export type State = ExchangeRatesState;

export const exchangeRatesFeatureKey = 'exchangeRates';

const reducer = createReducer(
  initialState,
  on(fromActions.loadExchangeRates, (state) => ({
    ...state,
    loadingStatus: LoadingStatus.LOADING
  })),
  on(fromActions.loadExchangeRatesSuccess, (state, { response: { exchangeRates } }) => ({
    ...state,
    exchangeRates,
    loadingStatus: LoadingStatus.SUCCEEDED
  })),
  on(fromActions.loadExchangeRatesFailure, (state) => ({
    ...state,
    loadingStatus: LoadingStatus.FAILED
  }))
);

export const exchangeRatesFeature = createFeature({
  name: exchangeRatesFeatureKey,
  reducer
});

const { selectExchangeRatesState } = exchangeRatesFeature;

export const selectExchangeRates = createSelector(selectExchangeRatesState, (state) => state.exchangeRates);
